export const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

const authFetch = (url, options = {}) => {
  const token = localStorage.getItem('token');
  const headers = { ...options.headers };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const resolvedUrl = url.startsWith('/') ? `${API_BASE}${url}` : url;
  return fetch(resolvedUrl, { ...options, headers });
};

export default authFetch;
